// ko strings for messages/upsell.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const upsell: Dict = {
  // Creator sheet, per reason: headline, lead, ticks, button.
  "upsell.creator.train.title": "Creator로 목소리 학습 시작하기",
  "upsell.creator.train.lead": "목소리 학습은 Creator에 포함돼요.",
  "upsell.creator.train.tick1": "목소리 무제한 학습",
  "upsell.creator.train.tick2": "Marble Run 영상, 매월 코인 50개",
  "upsell.creator.train.tick3": "지금 요금제의 모든 기능은 그대로",
  "upsell.creator.train.cta": "업그레이드하고 학습 시작하기",

  "upsell.creator.export.title": "1080p로 내보내기",
  "upsell.creator.export.lead":
    "Creator에서는 영상을 풀 1080p로 내보낼 수 있어요.",
  "upsell.creator.export.tick1": "1080p 내보내기",
  "upsell.creator.export.tick2": "Marble Run 영상, 매월 코인 50개",
  "upsell.creator.export.tick3": "목소리 무제한 학습",
  "upsell.creator.export.cta": "업그레이드하고 1080p로 내보내기",

  "upsell.creator.marble.title": "Marble Run은 Creator에서",
  "upsell.creator.marble.lead":
    "커버를 TikTok과 릴스에 바로 올릴 수 있는 Marble Run 영상으로 만들어 보세요.",
  "upsell.creator.marble.tick1": "매월 Marble Run 코인 50개",
  "upsell.creator.marble.tick2": "스튜디오 1080p 내보내기",
  "upsell.creator.marble.tick3": "목소리 무제한 학습",
  "upsell.creator.marble.cta": "업그레이드하고 Marble Run 만들기",

  "upsell.creator.video.title": "영상은 Creator에서",
  "upsell.creator.video.lead":
    "커버를 TikTok과 릴스에 공유할 수 있는 영상으로 만들어 보세요.",
  "upsell.creator.video.tick1": "공유용 영상, 매월 코인 50개",
  "upsell.creator.video.tick2": "스튜디오 1080p 내보내기",
  "upsell.creator.video.tick3": "목소리 무제한 학습",
  "upsell.creator.video.cta": "업그레이드하고 영상 만들기",

  // Creator sheet, shared.
  "upsell.creator.samplesOne": "보컬 준비 완료: 파일 {files}개, {duration}. ",
  "upsell.creator.samplesMany": "보컬 준비 완료: 파일 {files}개, {duration}. ",
  // "<Nothing> <to pay today>" or "<amount> <today>".
  "upsell.creator.nothing": "오늘",
  "upsell.creator.today": "오늘 결제",
  "upsell.creator.toPayToday": "결제 없음",
  "upsell.creator.thenMonth": "이후 월 {price}",
  "upsell.creator.credited":
    "이번 달 남은 기간의 요금은 크레딧으로 반영돼요. 언제든 해지할 수 있어요.",
  "upsell.creator.priceError":
    "업그레이드 가격을 불러오지 못했어요. 설정에서 언제든 업그레이드할 수 있어요.",
  "upsell.creator.upgrading": "업그레이드 중...",
  "upsell.creator.notNow": "나중에",
  "upsell.creator.payFailed":
    "결제가 완료되지 않아 아무것도 변경되지 않았어요. 설정에서 카드를 확인하고 다시 시도해 주세요.",

  // Pro Coin packs.
  "upsell.coins.title": "Pro 코인 받기",
  "upsell.coins.subtitle": "코인 1개로 공유용 영상 1개를 만들어요",
  "upsell.coins.coinAlt": "Pro 코인",
  "upsell.coins.useMarble": "Marble Run 영상",
  "upsell.coins.useLyric": "가사 영상",
  "upsell.coins.useTemplates": "모든 영상 템플릿",
  "upsell.coins.bestValue": "최고 가성비",
  "upsell.coins.mostCoins": "최다 코인",
  "upsell.coins.proCoins": "Pro 코인",
  "upsell.coins.each": "개당 {price}",
  "upsell.coins.purchase": "구매하기",
  "upsell.coins.footer":
    "Pro 코인은 바로 지급되며 만료되지 않아요. 코인 1개 = 영상 1개.",
};

export default upsell;
